import { lazy } from 'react';
import { authRoles } from 'app/auth';

const MtiUploaderPage = lazy(() => import('./MtiUploaderPage'));

const MtiUploaderConfig = {
  settings: {
    layout: {
      config: {
        topBanner: { display: false },
        footer: { display: false },
        healtheraHeader: {
          display: true,
          options: { pharmacySelector: true, background: 'marketing' },
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [{ path: 'mti-uploader', element: <MtiUploaderPage /> }],
};

export default MtiUploaderConfig;
